import React, { useEffect, useRef, useState } from "react";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Utils from "../../../common/manipurCommon/Utils";
import Swal from "sweetalert2";

const CompetitionPerformance = () => {

    const [compPerformanceList, setCompPerformanceList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [competitionList, setCompetitionList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [compPerformanceId, setCompPerformanceId] = useState("");
    const [totalParticipants, setTotalParticipants] = useState("");
    const [athleteId, setAthleteId] = useState([]);
    const [sportId, setSportId] = useState("");
    const [competitionId, setCompetitionId] = useState("");
    const [athleteRank, setAthleteRank] = useState("");
    const [athletePerformanceStatistic, setAthletePerformanceStatistic] = useState("");
    const [remarks, setRemarks] = useState("");
    const [status, setStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [athleteRows, setAthleteRows] = useState([
        { athleteId: "", athleteRank: "", athletePerformanceStatistic: "", remarks: "" }
    ]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCompetitionPerformance() {
            setIsLoading(true);
            const compPerformanceResponse = await func.competitionPerformance(null);
            setCompPerformanceList(Array.isArray(compPerformanceResponse) ? compPerformanceResponse : [])
            setIsLoading(false);
        }
        fetchCompetitionPerformance();
    }, [])

    const filteredData = compPerformanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const sportNameRender = (rowData) => {
        return <span>{rowData.sportName}</span>
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.Athlet}</span>
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.remarks}</span>
    };

    const athletePerfrmanceRender = (rowData) => {
        return <span>{rowData.athletePerformanceStatistic}</span>
    };

    const athleteRankRender = (rowData) => {
        return <span>{rowData.athleteRank}</span>
    };

    const totalParticipantsRender = (rowData) => {
        return <span>{rowData.totalParticipants}</span>
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const selectCustom = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    const customSelect = {
        control: (base) => ({
            ...base,
            borderRadius: "6px",     // tighter radius since the box is smaller
            background: "#FAFAFA",
            border: "none",
            boxShadow: "none",
            minHeight: "35px",       // ensures it never grows taller
            height: "35px",          // fixed height
        }),
        valueContainer: (base) => ({
            ...base,
            height: "30px",          // matches control
            display: "flex",
            alignItems: "center",    // centers text vertically
            padding: "0 6px",        // adjust padding to avoid text clipping
        }),
        input: (base) => ({
            ...base,
            margin: "0px",
            padding: "0px",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "30px",          // make dropdown arrow fit
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: "2px",          // tighter padding for small height
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: "2px",          // smaller clear (x) button
        }),
        placeholder: (base) => ({
            ...base,
            color: "#aaa",
        }),
        singleValue: (base) => ({
            ...base,
            color: "#333",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    async function newCompetitionPerformance() {
        setIsEdit(false);
        setAthleteId([]);
        setSportId("");
        setCompetitionId("");
        setAthleteRank("");
        setAthletePerformanceStatistic("");
        setRemarks("");
        setAthleteRows([]);
        const athltResponse = await func.listActiveAthletes();
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
        const compResponse = await func.competitions(null);
        setCompetitionList(Array.isArray(compResponse) ? compResponse : [])
        setOpenModal(true);
    }

    function addAthleteRow() {
        if (athleteRows.length < 5) {
            setAthleteRows([
                ...athleteRows,
                { athleteId: "", athleteRank: "", athletePerformanceStatistic: "", remarks: "" }
            ]);
        } else {
            Swal.fire("You can add only upto 5 athletes");
        }
    }

    function removeAthleteRow(index: number) {
        setAthleteRows(athleteRows.filter((_, i) => i !== index));
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCompetitionPerformance(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const compId = rowData.competitionsPerformanceId;
        return (
            <Link to="#" onClick={() => deleteCompetitionPerformance(compId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editCompetitionPerformance(rowData: { competitionId: any; competitionsPerformanceId: any; }) {
        const compPrfmncId = rowData.competitionsPerformanceId;
        const compId = rowData.competitionId;
        const compResponse = await func.competitions(null);
        setCompetitionList(Array.isArray(compResponse) ? compResponse : [])
        const response = await func.getSportAthleteByCompetition(compId);
        setSportList(response?.sportList ?? []);
        setAthleteList(response?.athleteList ?? []);
        setIsEdit(true);
        const getDetails = await func.competitionPerformance(compPrfmncId);
        setCompPerformanceId(getDetails.competitionsPerformanceId);
        setSportId(getDetails.sportsId);
        setAthleteId(getDetails.athleteId);
        setCompetitionId(getDetails.competitionId);
        setAthleteRank(getDetails.athleteRank);
        setAthletePerformanceStatistic(getDetails.athletePerformanceStatistic);
        setRemarks(getDetails.remarks);
        setStatus(getDetails.status);
        setAthleteRows([
            {
                athleteId: getDetails.athleteId,
                athleteRank: getDetails.athleteRank,
                athletePerformanceStatistic: getDetails.athletePerformanceStatistic,
                remarks: getDetails.remarks
            }
        ]);
        setOpenModal(true);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCompetitionPerformance();
            } else {
                const formData = new FormData();
                formData.append("competitionId", competitionId);
                formData.append("sportsId", sportId);
                formData.append("totalParticipants", totalParticipants);
                formData.append("athleteInfo", JSON.stringify(athleteRows))

                const compPrfmc = api.competitionPerformance;
                fetch(compPrfmc, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateCompetitionPerformance() {
        const formData = new FormData();
        formData.append("athleteId", athleteId);
        formData.append("competitionId", competitionId);
        formData.append("sportsId", sportId);
        formData.append("athleteRank", athleteRank);
        formData.append("athletePerformanceStatistic", athletePerformanceStatistic);
        formData.append("remarks", remarks);
        formData.append("status", status);
        const updateCompPrfmnc = api.competitionPerformance + '/' + compPerformanceId;
        fetch(updateCompPrfmnc, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteCompetitionPerformance(compId) {
        const deleteCompPrfmnc = api.competitionPerformance + '/' + compId + '/' + 0;
        fetch(deleteCompPrfmnc, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }


    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competition Performance</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCompetitionPerformance() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Competition Performance">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionName"
                                                header="Competition Name"
                                                body={compNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportName"
                                                header="Sport Name"
                                                body={sportNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="Athlet"
                                                header="Athlet Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="remarks"
                                                header="Remarks"
                                                body={remarksRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athletePerformanceStatistic"
                                                header="Athlet Performance"
                                                body={athletePerfrmanceRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteRank"
                                                header="Athlet Rank"
                                                body={athleteRankRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="totalParticipants"
                                                header="Total Participants"
                                                body={totalParticipantsRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="xl"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Competition Performance</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody style={{ maxHeight: "500px", overflowY: "scroll" }}>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Competition</label>
                                    <Select
                                        value={competitionList.find(comp => comp.competitionId === competitionId) ? {
                                            value: competitionId,
                                            label: competitionList.find(comp => comp.competitionId === competitionId).competitionName
                                        } : null}
                                        onChange={async (e) => {
                                            setCompetitionId(e.value);
                                            const response = await func.getSportAthleteByCompetition(e.value);
                                            setSportList(response?.sportList ?? []);
                                            setAthleteList(response?.athleteList ?? []);

                                        }}
                                        required
                                        styles={selectCustom}
                                        placeholder="Select Competition"
                                        options={competitionList.map(comp => ({
                                            value: comp.competitionId,
                                            label: comp.competitionName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Sport</label>
                                    <Select
                                        value={sportList.find(sprt => sprt.competitionsportsId === sportId) ? {
                                            value: sportId,
                                            label: sportList.find(sprt => sprt.competitionsportsId === sportId).sportName
                                        } : null}
                                        onChange={async (e) => {
                                            setSportId(e.value);
                                        }}
                                        required
                                        styles={selectCustom}
                                        placeholder="Select Sport"
                                        options={sportList.map(sprt => ({
                                            value: sprt.competitionsportsId,
                                            label: sprt.sportName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Total Participants</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="totPrts"
                                        style={{ borderRadius: "5px", height: "70px" }}
                                        placeholder="Enter Total Participants"
                                        required
                                        value={totalParticipants}
                                        onChange={(e) => setTotalParticipants(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Link
                                    to="#"
                                    className="btn text-end"
                                    onClick={() => { addAthleteRow() }}
                                    data-bs-toggle="tooltip"
                                    style={{ fontSize: "24px", padding: "0px" }}
                                    title="Add Athlete Performance">
                                    <i className="feather-plus" />&nbsp;
                                </Link>
                            </div>
                            {athleteRows.map((row, index) => (
                                <>
                                    <div className="row" key={index}>
                                        <Link
                                            to="#"
                                            className="btn text-end"
                                            onClick={() => { removeAthleteRow(index) }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Remove Athlete Row">
                                            <i className="feather-minus" />&nbsp;
                                        </Link>
                                        <div className="col-lg-3">
                                            <div className="input-space">
                                                <label className="form-label">Athlete</label>
                                                <Select
                                                    value={athleteList.find(athlt => athlt.userId === row.athleteId) ? {
                                                        value: row.athleteId,
                                                        label: athleteList.find(athlt => athlt.userId === row.athleteId).athleteName
                                                    } : null}
                                                    onChange={(e) => {
                                                        const updatedRows = [...athleteRows];
                                                        updatedRows[index].athleteId = e.value;
                                                        setAthleteRows(updatedRows);
                                                    }}
                                                    required
                                                    styles={customSelect}
                                                    placeholder="Select Athlete"
                                                    options={athleteList.map(athlt => ({
                                                        value: athlt.userId,
                                                        label: athlt.athleteName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="input-space">
                                                <label className="form-label">Athlete Rank</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={row.athleteRank}
                                                    onChange={(e) => {
                                                        const updatedRows = [...athleteRows];
                                                        updatedRows[index].athleteRank = e.target.value;
                                                        setAthleteRows(updatedRows);
                                                    }}
                                                    style={{ height: "20px", padding: "17px" }}
                                                    placeholder="Enter Athlete Rank"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="input-space">
                                                <label className="form-label">Athlete Performance Statistic</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={row.athletePerformanceStatistic}
                                                    onChange={(e) => {
                                                        const updatedRows = [...athleteRows];
                                                        updatedRows[index].athletePerformanceStatistic = e.target.value;
                                                        setAthleteRows(updatedRows);
                                                    }}
                                                    style={{ height: "20px", padding: "17px" }}
                                                    placeholder="Enter Performance Statistic"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="input-space">
                                                <label className="form-label">Remarks</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={row.remarks}
                                                    onChange={(e) => {
                                                        const updatedRows = [...athleteRows];
                                                        updatedRows[index].remarks = e.target.value;
                                                        setAthleteRows(updatedRows);
                                                    }}
                                                    style={{ height: "20px", padding: "17px" }}
                                                    placeholder="Enter Remarks"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}
                            {isEdit ?
                                <>
                                    <div className="col-lg-6 mt-10">
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={status === '1'}
                                                        id="status"
                                                        onChange={(e) => {
                                                            setStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                            {/* </div> */}
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};

export default CompetitionPerformance;